import React, { useEffect } from 'react';
import GameManager from '../GameManager/GameManager';
import GameContext from '../store/GameContext';

import { GameObject } from '@magicyard/doodledash-game/src/Game';
import { updateAnalyticsData } from '@magicyard/shared/src/analytics';

const Board = (props: { G: GameObject; onStartNewGame: () => void; onTryDifferentGames?: () => void }) => {
  const { matchID } = props.G;

  useEffect(() => {
    updateAnalyticsData({ matchId: matchID });
  }, [matchID]);
  return (
    <GameContext.Provider value={props.G}>
      <GameManager onStartNewGame={props.onStartNewGame} onTryDifferentGames={props.onTryDifferentGames} />
    </GameContext.Provider>
  );
};

export default Board;
